// extracted by mini-css-extract-plugin
module.exports = {"container":"PlayerName_container__3j3SP","name":"PlayerName_name__3SloW"};